import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerPeriodoDisponibilidad = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Informe/ObtenerPeriodosDisponibilidad",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerPeriodoDisponibilidad };
